var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { T } from 'helpers/i18n';
import { toDate, toMoney } from 'helpers/Format';
import { dateMonthsBefore } from 'helpers/Date';
import { Modal, Table } from 'components';
import { Button, DatePicker } from 'elements';
import { Search } from 'helpers/FuzzySearch';
import theme from 'Theme';
class TicketsReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            from: dateMonthsBefore(new Date(), 1),
            to: new Date(),
            fromVisible: false,
            toVisible: false,
            searchTerm: undefined,
        };
        this.handleSearch = (value) => {
            this.setState({ searchTerm: value });
        };
        this.toggleFromModal = () => this.setState({ fromVisible: !this.state.fromVisible });
        this.toggleToModal = () => this.setState({ toVisible: !this.state.toVisible });
        this.handleFromChange = (_, from) => {
            // this.toggleFromModal()
            this.setState({ from });
        };
        this.handleToChange = (_, to) => {
            // this.toggleToModal()
            this.setState({ to });
        };
        this.handleFromKeyPress = (keyCode) => {
            if (keyCode === 13)
                this.toggleFromModal();
        };
        this.handleToKeyPress = (keyCode) => {
            if (keyCode === 13)
                this.toggleToModal();
        };
        this.filteredItems = items => {
            const { from, to, searchTerm } = this.state;
            // return items
            const filtradosFecha = items.filter((item) => {
                return item.datecheck.getTime() < to.getTime() && item.datecheck.getTime() > from.getTime();
            });
            if (searchTerm) {
                const result = Search(searchTerm, filtradosFecha, ['username', 'businessUnit', 'numero', 'terminal', 'operationLineName', 'stretchName']);
                /*console.log( 'TicketsReport - filteredItems - searchTerm: ', searchTerm )
                console.log( 'TicketsReport - filteredItems - filtradosFecha: ', filtradosFecha )
                console.log( 'TicketsReport - filteredItems - result: ', result )*/
                return result;
            }
            return filtradosFecha;
        };
        this.handleOnSelectItem = (item) => {
            // console.log( 'TicketsReport - handleOnSelectItem - item: ', item)
            const { items } = this.props;
            const ticket = items.filter((value) => value.id === item.id);
            this.props.onSelectItem(ticket[0]);
        };
        // Pongo hora al final del día, para que filtre los que se emitan después de haber
        // renderizado, y que no haya que meter a mano la hora
        const date = new Date();
        date.setHours(23, 59, 59, 1000);
        this.state.to = date;
    }
    render() {
        const _a = this.props, { header, items, total, format, filters, onSelectItem } = _a, props = __rest(_a, ["header", "items", "total", "format", "filters", "onSelectItem"]);
        const { from, to, fromVisible, toVisible } = this.state;
        const filteredItems = this.filteredItems(items);
        const fomatedItems = format(filteredItems);
        // console.log('TicketsReport - render - items.length', items.length)
        // console.log('TicketsReport - render - filteredItems.length', filteredItems.length)
        // console.log('TicketsReport - render - filteredItems', filteredItems)
        return (React.createElement(Wrapper, null,
            React.createElement(Header, null,
                T('from'),
                ":",
                ' ',
                React.createElement(Button, { onClick: this.toggleFromModal }, toDate(from)),
                T('to'),
                ": ",
                React.createElement(Button, { onClick: this.toggleToModal }, toDate(to))),
            total && (React.createElement(Total, null,
                T('total'),
                " ",
                toMoney(total(filteredItems)))),
            React.createElement(Table, Object.assign({ onSelectItem: this.handleOnSelectItem, width: "200%", handleSearch: this.handleSearch }, props, { items: fomatedItems, header: header, search: this.props.search ? this.props.search : false })),
            fromVisible && (React.createElement(Modal, { title: T('from') },
                React.createElement(DatePicker, { withTime: true, name: 'from', date: from, onChange: this.handleFromChange, onKeyPress: this.handleFromKeyPress }),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    } },
                    React.createElement(Button, { style: { backgroundColor: theme.color.background, margin: '5px' }, onClick: this.toggleFromModal }, 'OK')))),
            toVisible && (React.createElement(Modal, { title: T('to') },
                React.createElement(DatePicker, { withTime: true, name: 'to', date: to, onChange: this.handleToChange, onKeyPress: this.handleToKeyPress }),
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%'
                    } },
                    React.createElement(Button, { style: { backgroundColor: theme.color.background, margin: '5px' }, onClick: this.toggleToModal }, 'OK'))))));
    }
}
export default TicketsReport;
const Wrapper = cxs('div')({
    // overflowY: 'auto',
    // height: Theme.common.devices.desktopHeight,
    height: '600px',
    marginBottom: Theme.size.bar,
});
const Header = cxs('div')({
    paddingLeft: Theme.size.space[1],
});
const Total = cxs('div')({
    padding: Theme.size.space[1],
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    textAlign: 'right'
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/components/TicketsReport.tsx
// module id = 106
// module chunks = 0